import { DIRECTIONS, } from '../components/studentView/promptStep'
import { DEFAULT_CONCEPT_UIDS, conjunctionsForActivityType, evidenceShadowQuestionUid } from '../../../constants/evidence'
import { calculateScoreFromConceptResults } from '../../Shared/activityScoring'

const reachedTarget = (response) => response.optimal === true || response.target_optimal === true

export const generateConceptResults = (currentActivity, submittedResponses) => {
  const activeConjunctions = conjunctionsForActivityType(currentActivity.activity_type)
  const conjunctionToQuestionNumber = activeConjunctions.reduce((acc, conjunction, index) => {
    acc[conjunction] = index + 1
    return acc
  }, {})

  const conceptResults = []

  for (const [promptID, responses] of Object.entries(submittedResponses)) {
    const prompt = Object.values(currentActivity.prompts).filter((prompt) => String(prompt.id) === String(promptID))[0]
    // Every Evidence prompt targets its conjunction's fixed concept, regardless
    // of ai_type (mirrors the server's Evidence::GenAi::CONCEPT_MAPPING).
    const questionConceptUid = DEFAULT_CONCEPT_UIDS[prompt.conjunction]
    responses.forEach((response, index) => {
      const attempt = index + 1
      const conceptResultMetadata = {
        answer: response.entry,
        attemptNumber: attempt,
        correct: response.optimal ? 1 : 0,
        directions: (attempt === 1) ? DIRECTIONS : responses[index - 1].feedback,
        prompt: prompt.text,
        questionNumber: conjunctionToQuestionNumber[prompt.conjunction],
        questionScore: responses.some(reachedTarget) ? 1.0 : 0.0,
        question_concept_uid: questionConceptUid,
        question_uid: evidenceShadowQuestionUid(prompt.id),
        // omitted rather than sent as 0 when the payload carried no value, so the server stores null
        ...(typeof response.target_optimal === 'boolean' ? { target_optimal: response.target_optimal ? 1 : 0 } : {})
      }

      // a response that hit the target without being fully optimal earns a
      // second, full-credit row against the question's concept
      if (response.optimal !== true && response.target_optimal === true) {
        conceptResults.push({
          concept_uid: questionConceptUid,
          question_type: 'comprehension',
          metadata: {
            ...conceptResultMetadata,
            ...{correct: 1}
          }
        })
      }

      conceptResults.push({
        concept_uid: response.concept_uid,
        question_type: 'comprehension',
        metadata: conceptResultMetadata
      })
    })
  }
  return conceptResults
}

export const generatePercentageScore = (conceptResults) => {
  if (!conceptResults.length) return null;
  return calculateScoreFromConceptResults(conceptResults);
};
